
import { defineComponent, computed, reactive, onMounted, toRefs } from 'vue'
import { useForm } from '@ant-design-vue/use'
import { GlobalDataProps } from '../../store/index'
import { useStore } from 'vuex'
import { forEach } from 'lodash-es'
import useSaveWork from '@/hooks/useSaveWork'
import { generateQRCode, timeout } from '../../helper'
import StyledUploader from '@/components/StyledUploader.vue'
import { RespUploadData } from '@/store/respTypes'
import { DEFAULT_COVER_IMAGE } from '@/utils/consts'

export default defineComponent({
  components: {
    StyledUploader
  },
  props: {
    visible: {
      type: Boolean,
      defaults: false
    }
  },
  emits: ['update:visible'],
  setup(props, { emit }) {
    const store = useStore<GlobalDataProps>()
    const pageState = computed(() => store.state.editor.page)
    const previewURL = computed(
      () => `${process.env.VUE_APP_H5_URL}/pages/${pageState.value.id}-${pageState.value.uuid}`
    )
    const { title, desc, setting } = pageState.value
    const { saveWork, saveIsLoading } = useSaveWork(true)
    const form = reactive({
      title: title || '',
      desc: desc || '',
      uploaded: { data: { url: (setting && setting.shareImg) || DEFAULT_COVER_IMAGE } }
    })
    const rules = reactive({
      title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
      desc: [{ required: true, message: '描述不能为空', trigger: 'blur' }]
    })

    onMounted(async () => {
      try {
        await timeout(100)
        await generateQRCode('preview-barcode-container', previewURL.value)
      } catch (e) {
        console.error(e)
      }
    })
    const updateAvatar = (rawData: { resp: RespUploadData; file: File }) => {
      const url = rawData.resp.data.urls[0]
      form.uploaded = {
        data: { url }
      }
    }
    const { validate } = useForm(toRefs(form), toRefs(rules))
    const validateAndSave = async () => {
      await validate()

      forEach(form, (value, key) => {
        if (key === 'uploaded' && typeof value !== 'string' && typeof value !== 'boolean') {
          store.commit('updatePage', { key: 'shareImg', value: value.data.url, isSetting: true })
        } else {
          store.commit('updatePage', { key, value, isRoot: true })
        }
      })
      await saveWork()
      emit('update:visible', false)
    }
    const onCancel = () => {
      emit('update:visible', false)
    }
    return {
      pageState,
      previewURL,
      form,
      rules,
      saveIsLoading,
      validateAndSave,
      onCancel,
      updateAvatar
    }
  }
})
